<template>
	<div class="login_page">
		<svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto"><defs><path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"></path></defs><g class="parallax"><use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7"></use><use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)"></use><use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)"></use><use xlink:href="#gentle-wave" x="48" y="7" fill="#fff"></use></g></svg>
		<div class="form_box">
			<h3 class="tit">登 录</h3>
			<div class="row border_b">
				<span class="label">账号</span>
				<input v-model="account" type="text" placeholder="请输入账号">
			</div>
			<div class="row border_b">
				<span class="label">密码</span>
				<input v-model="password" type="password" placeholder="请输入密码">
			</div>
			<button style="display: block;width: 100%;height: 50px;margin-top: 30px;font-size: 18px;" @click="handleLoginClick">登 录</button>
		</div>
	</div>
</template>

<script>
	import Api from '../../api/api.js';
	import { mapMutations } from 'vuex';
	import Login from '../../utils/login.js';
	
	export default {
		data() {
			return{
				account: '',
				password: ''
			}
		},
		methods: {
			/***************** @Events ********************/
			// 点击登录
			handleLoginClick() {
				if (!this.account.trim()) {
					this.swal('请输入账号', {button: false});
					return false;
				}
				if (!this.password.trim()) {
					this.swal('请输入密码', {button: false});
					return false;
				}
				this.login();
			},
			
			/***************** @Function ********************/
			// 登录
			login() {
				const that = this;
				that.setLoading(true);
				let requestData = {
					code: null,
					id: null,
					username: that.account,
					password: that.password,
					type: 'training',
					grant_type: 'password'
				};
				Api.login(requestData).then((res) => {
					if (res.data.success) {
						// console.log(res);
						var _kj = res.headers.ttkj,
							_kt = res.headers.ttkt;
						Login.setSafeInfo(_kj, _kt);
						Login.setSafeInfoCache(_kj, _kt);
						that.setLoading(false);
						that.$router.go(-1);
					} else {
						that.setLoading(false);
						that.swal(res.data.message, {button: false});
					}
				}, (e) => {
					that.setLoading(false);
					that.swal(e.message, {button: false});
				});
			},
			
			...mapMutations({
				'setLoading': 'setLoading'
			})
		}
	}
</script>

<style scoped>
	.login_page{ position: relative;padding: 150px 0;background: linear-gradient(60deg, rgba(84,58,183,1) 0%, rgba(0,172,193,1) 100%); }
	.waves {  position:absolute;width: 100%;bottom: 0;left: 0; }.parallax >use {  animation: move-forever 25s cubic-bezier(.55,.5,.45,.5)     infinite;}.parallax >use:nth-child(1) {  animation-delay: -2s;  animation-duration: 7s;}.parallax >use:nth-child(2) {  animation-delay: -3s;  animation-duration: 10s;}.parallax >use:nth-child(3) {  animation-delay: -4s;  animation-duration: 13s;}.parallax >use:nth-child(4) {  animation-delay: -5s;  animation-duration: 20s;}@keyframes move-forever {  0% {   transform: translate3d(-90px,0,0);  }  100% {     transform: translate3d(85px,0,0);  }}
	.login_page .form_box{ position: relative;width: 500px;margin: 0 auto;padding: 40px;border-radius: 5px;background: rgba(255, 255, 255, .5); }
	.login_page .form_box .tit{ font-size: 30px;text-align: center;line-height: 42px; }
	.login_page .row{ position: relative;height: 51px;margin-top: 20px;padding: 0 0 0 50px; }
	.login_page .label{ display: block;position: absolute;width: 50px;top: 0;left: 0;font-size: 16px;line-height: 50px; }
	.login_page .row input{ display: block;width: 100%;padding: 10px;font-size: 16px;line-height: 30px; }
</style>
